// eslint-disable-next-line import/no-unresolved
import KeenSlider from 'https://cdn.skypack.dev/pin/keen-slider@v6.6.14-XM80lRoYRUdkHMpUfMaX/mode=imports,min/optimized/keen-slider.js'

const { setInitialised, useArrows, setScrollable } = window.BAO.Carousel.plugins

class GalleryCarousel extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['slider', 'slide', 'next', 'previous']
  }

  connectedCallback () {
    super.connectedCallback()

    const viewportWidth =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth

    if (
      viewportWidth >= 768 &&
      viewportWidth < 901 &&
      this.els.slide.elements.length < 3
    ) {
      return
    }
    if (viewportWidth >= 901 && this.els.slide.elements.length <= 3) return
    if (viewportWidth >= 1201 && this.els.slide.elements.length <= 4) return

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slider.element,
      {
        selector: this.els.slide.elements,
        loop: true,
        mode: 'snap',
        slides: {
          origin: 'center',
          perView: 1.3,
          spacing: 10,
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              origin: 'center',
              perView: 2.3,
              spacing: 20,
            },
          },
          '(min-width: 901px)': {
            slides: {
              origin: 'center',
              perView: 3.1,
              spacing: 20,
            },
          },
          '(min-width: 1201px)': {
            initial: 2,
            slides: {
              origin: 'center',
              perView: 4,
              spacing: 30,
            },
          },
        },
      },
      [
        setInitialised(),
        setScrollable(),
        useArrows({
          next: this.els.next.element,
          previous: this.els.previous.element,
        }),
      ],
    )
  }
}

if (!customElements.get('gallery-carousel')) {
  customElements.define('gallery-carousel', GalleryCarousel)
}
